import React from 'react';
import store from 'store';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import AppContainer from './containers/AppContainer';
import MenuEventsSubscriber from './components/MenuEventsSubscriber/MenuEventsSubscriber';

import { LayoutProvider, StoreProvider } from '../src/contexts';
import { setAuthorizationToken } from '../src/utils/API';

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  const authToken = store.get('authenticationToken');

  if (!!authToken) {
    setAuthorizationToken(authToken);
  }

  return (
    <QueryClientProvider client={queryClient}>
      <MenuEventsSubscriber />
    <LayoutProvider>
      <StoreProvider>
        <AppContainer />
      </StoreProvider>
    </LayoutProvider>
    </QueryClientProvider>
  );
}

export default App;
